/*
 * This Function should override the original imagesloaded-function;
 * If images have size-attributes (width & height), we should not wait for the image to be loaded
 * if an images in the set has not both size-attributes, the original imagesloaded-function shall be called
 * - may be optimized dramatically ;-)
 */
 (function () {
  'use strict';

	var original = require('imagesloaded');
	var helper = require('./generic.js');
	var logger = new (require('../helpers/logger.js'))("ImagesLoadedOrDimensionsSet").setColor("#ABABAB").setDebug(true);
  var jquery = require('jquery');

  function ImagesLoadedOrDimensionsSet( elem, options, onAlways ) {
    original.call(this, elem, options, onAlways); // call ImagesLoaded constructor.
  }

	ImagesLoadedOrDimensionsSet.prototype = Object.create(original.prototype);
  ImagesLoadedOrDimensionsSet.prototype.constructor = original;
	ImagesLoadedOrDimensionsSet.makeJQueryPlugin = function( jquery ) {
	  jquery = jquery || window.jquery;
	  if ( !jquery ) {
	    return;
	  }
	  jquery.fn.imagesLoadedOrDimensionsSet = function( options, callback ) {
	    var instance = new ImagesLoadedOrDimensionsSet( this, options, callback );
	    return instance.jqDeferred.promise( $(this) );
	  };
	};
	// try making plugin
	ImagesLoadedOrDimensionsSet.makeJQueryPlugin(jquery);

	ImagesLoadedOrDimensionsSet.prototype.check = function check(){
		var _this = this;
		this.progressedCount = 0;
		this.hasAnyBroken = false;
		// complete if no images
		if ( !this.images.length ) {
			this.complete();
			return;
		}

	  function onProgress( image, elem, message ) {
	    // HACK - Chrome triggers event before object properties have changed. #83
	    setTimeout( function() {
	      _this.progress( image, elem, message );
	    });
	  }

		this.images.forEach( function( loadingImage ) {
			var width = loadingImage.img.width;
			var height = loadingImage.img.height;
			var hasWidthSet = !helper.undefOrNull(width) && width > 0;
			var hasHeightSet = !helper.undefOrNull(height) && height > 0;
			loadingImage.once( 'progress', onProgress );
			if (hasWidthSet && hasHeightSet){
				logger.debug("Resolving image via dimensions", loadingImage.img);
				loadingImage.confirm( true, 'givenDimensions' );
			} else {
				logger.debug("Resolving image via original check", loadingImage.img);
				loadingImage.check();
			}
		});
	};

	module.exports = ImagesLoadedOrDimensionsSet;

}());



//////////////////
// WEBPACK FOOTER
// ./src/helpers/ImagesLoadedOrDimensionsSet.js
// module id = 32
// module chunks = 0